__webpack_require__.p = "https://js-static.iimjobs.com/production/4.12.0/_next/";